<template>
  <vs-popup class="normal-cleaning-popup" title="적정 클리닝 확인서" :active.sync="popupActive">
    <div class="text-right">
      <vs-button class="mr-2" @click="checkAll">전체 양호</vs-button>
      <vs-button class="mr-2" @click="save">저장</vs-button>
      <vs-button @click="print">프린트</vs-button>
    </div>
    <div class="normal-cleaning-page">
      <span class="text-sm">[별지 제5호의 2서식]</span>
      <table class="w-full">
        <colgroup>
          <col width="52" />
          <col width="42" />
          <col width="42" />
          <col width="98" />
          <col width="44" />
          <col width="60" />
          <col width="47" />
          <col width="45" />
          <col width="45" />
          <col width="50" />
        </colgroup>
        <tbody>
          <tr>
            <td colspan="10" class="text-2xl font-bold">적정 클리닝 확인서</td>
          </tr>
          <tr>
            <th rowspan="3">필터<br/>클리닝<br/>일자</th>
            <td colspan="3" rowspan="3"></td>
            <th rowspan="3">차량<br/>소유자</th>
            <th>이름</th>
            <td colspan="4" class="relative">{{ audit.ownerName }}
              <span style="position: absolute; right: 30px;">(인)</span>
              <img :src="audit.signature" style="position: absolute; top: -16px; right: 0; z-index: 0; width: 64px;">
            </td>
          </tr>
          <tr>
            <th>연락처</th>
            <td colspan="4">{{ audit.lastPhone }}</td>
          </tr>
          <tr>
            <th>관계</th>
            <td colspan="4" class="relative">
              <feather-icon :icon="audit.relation === 'self' ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; " svgClasses="h-6 w-5" @click="toggleRelation('self')"/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleRelation('self')">본인</span>
              &nbsp;<feather-icon :icon="audit.relation === 'family' ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; " svgClasses="h-6 w-5" @click="toggleRelation('family')"/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleRelation('family')">가족</span>
              &nbsp;<feather-icon :icon="audit.relation === 'staff' ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; " svgClasses="h-6 w-5" @click="toggleRelation('staff')"/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleRelation('staff')">직원</span>
              &nbsp;<feather-icon :icon="audit.relation === 'friend' ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; " svgClasses="h-6 w-5" @click="toggleRelation('friend')"/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<span @click="toggleRelation('friend')">지인</span>
            </td>
          </tr>
          <tr>
            <th rowspan="2">클리닝<br/>센터</th>
            <td colspan="3" class="text-left pl-4">(회사명) 서천제일 자동차 공업사</td>
            <th colspan="2">저감장치 종류</th>
            <td colspan="4">{{ $deviceTypes[audit.certificationNumber] }}</td>
          </tr>
          <tr>
            <td colspan="3" class="text-left pl-4" style="position: relative;">(클리닝 담당자) 김대명
              <span style="position: absolute; right: 30px;">(인)</span>
              <img src="@/assets/images/kdm.png" style="position: absolute; top: -6px; right: 5px; z-index: 0; width: 50px;">
            </td>
            <th colspan="2">차량번호</th>
            <td colspan="4">{{ audit.vehicleNumber }} / {{ audit.currentVehicleNumber }}</td>
          </tr>
          <tr>
            <td colspan="10" class="h-1"></td>
          </tr>
          <tr>
            <th>점검</th>
            <th colspan="2">항목</th>
            <th colspan="4">내용</th>
            <th colspan="2">점검내용</th>
            <th>비고</th>
          </tr>
          <tr>
            <th rowspan="6">필터<br/>점검</th>
            <td rowspan="3">클리닝<br/>장비</td>
            <td rowspan="2">공기<br/>압축기</td>
            <td colspan="4" class="text-left">용량 탱크 압력이 7bar일 때 1.5m3/min 이상,<br/>9bar일 때 1.4m3/min 이상의 공기를 공급여부</td>
            <td class="pr-6 relative">정상<feather-icon :icon="audit.checklist && audit.checklist['compressure'] === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('compressure', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist['compressure'] === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('compressure', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="4" class="text-left">분사압력 7~8bar인지 확인</td>
            <td class="pr-6 relative">정상<feather-icon :icon="audit.checklist && audit.checklist['spray'] === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('spray', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist['spray'] === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('spray', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td>히팅<br/>시스템</td>
            <td colspan="4" class="text-left">필터 내부 수분·유분 제거를 위한 150~200℃ 온도 제어 가능한지 확인</td>
            <td class="pr-6 relative">정상<feather-icon :icon="audit.checklist && audit.checklist.heat === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('heat', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.heat === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('heat', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">필터상태</td>
            <td colspan="4" class="text-left">필터 파손 여부(육안검사)</td>
            <td class="pr-6 relative">정상<feather-icon :icon="audit.checklist && audit.checklist.status === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('status', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.status === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('status', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">배압</td>
            <td colspan="4" class="text-left">배압이 20mbar 이하</td>
            <td class="pr-6 relative">이하<feather-icon :icon="audit.checklist && audit.checklist.backPressure === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('backPressure', 1)"/></td>
            <td class="pr-6 relative">이상<feather-icon :icon="audit.checklist && audit.checklist.backPressure === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('backPressure', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">배기관</td>
            <td colspan="4" class="text-left">저감장치 1,2차 배관 상태 점검</td>
            <td class="pr-6 relative">양호<feather-icon :icon="audit.checklist && audit.checklist.pipe === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('pipe', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.pipe === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('pipe', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <th rowspan="6">필터<br/>교체<br/>후<br/>점검</th>
            <td colspan="2">센서위치</td>
            <td colspan="4" class="text-left">T1,T2,T3,압력호스 위치가 정확한지 확인</td>
            <td class="pr-6 relative">양호<feather-icon :icon="audit.checklist && audit.checklist.sensor === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('sensor', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.sensor === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('sensor', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">체결불량</td>
            <td colspan="4" class="text-left">볼트너트 등 각 체결부위에 체결상태 확인</td>
            <td class="pr-6 relative">양호<feather-icon :icon="audit.checklist && audit.checklist.error === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('error', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.error === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('error', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">메인커넥터</td>
            <td colspan="4" class="text-left">딸칵소리가 나는 등 적정 체결 확인</td>
            <td class="pr-6 relative">양호<feather-icon :icon="audit.checklist && audit.checklist.connector === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('connector', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.connector === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('connector', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">압력</td>
            <td colspan="4" class="text-left">배압 표출 및 정상여부 확인</td>
            <td class="pr-6 relative">양호<feather-icon :icon="audit.checklist && audit.checklist.pressure === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('pressure', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.pressure === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('pressure', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">수동재생</td>
            <td colspan="4" class="text-left">재생시 백연이나 LEAK(연료누설) 확인 및 정상작동여부 등 확인</td>
            <td class="pr-6 relative">양호<feather-icon :icon="audit.checklist && audit.checklist.manual === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('manual', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.manual === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('manual', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="2">자기진단</td>
            <td colspan="4" class="text-left">저감장치 OBD 에러 발생 여부 및 차량 자체 OBD가 적용된 차량은 자기진단기 활용하여 이상 진단 실시</td>
            <td class="pr-6 relative">양호<feather-icon :icon="audit.checklist && audit.checklist.self === 1 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('self', 1)"/></td>
            <td class="pr-6 relative">불량<feather-icon :icon="audit.checklist && audit.checklist.self === 0 ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important; right: 4px;" svgClasses="h-6 w-5" @click.stop="toggleChecklist('self', 0)"/></td>
            <td></td>
          </tr>
          <tr>
            <td colspan="10">특이사항</td>
          </tr>
          <tr>
            <td colspan="10" class="pb-2 text-left">
              <p class="mt-2 ml-4 relative">
                <feather-icon :icon="audit.normalCleaningNote === 'impossible' ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important;" svgClasses="h-6 w-5" @click="checkNormalCleaningNote('impossible')"/>
                <label class="ml-6" @click="checkNormalCleaningNote('impossible')">OBD 전원 불량/모비스 제품으로 부품 수급 불가 (구조변경일 기준 2009년 이전 장착 차량)</label>
              </p>
              <p class="mt-2 ml-4 relative">
                <feather-icon :icon="audit.normalCleaningNote === 'refuse' ? 'CheckSquareIcon' : 'SquareIcon'" color="primary" style="position: absolute !important;" svgClasses="h-6 w-5" @click="checkNormalCleaningNote('refuse')"/>
                <label class="ml-6" @click="checkNormalCleaningNote('refuse')">OBD 전원 불량(노트북 배압 확인)/유상수리 안내했으나 차주 수리거부 (보증경과차량)</label>
              </p>
              <p class="mt-2 ml-4 relative">
                <label>본인은 상기 고장 사항을 확인 하였으며 수리를 하지 않고 필터 클리닝만 실시 하는데 동의합니다.</label>
              </p>
            </td>
          </tr>
          <tr>
            <td class="text-left" colspan="10">
              <p class="w-full text-center mt-4">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;년&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;월&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;일</p>
              <p class="pl-2 mt-4 mb-4">다음 차량은 장착된 배출가스 저감장치의 성능유지관리를 위한 클리닝의 일환으로 기존 장착 필터를 클리닝(청소)된 필터로 교환하는 것에 동의하였음을 확인합니다.</p>
              <table class="w-full no-border mb-4">
                <colgroup>
                  <col width="50%" />
                  <col width="30%" />
                  <col width="20%" />
                </colgroup>
                <tbody>
                  <tr>
                    <td class="text-right pr-2 text-lg">차량소유자</td>
                    <td class="text-left">{{ audit.ownerName }}</td>
                    <td style="position: relative;">
                      <span style="position: absolute; top: 4px; right: 110px;">(인)</span>
                      <img :src="audit.signature" style="position: absolute; top: -16px; right: 90px; z-index: 0; width: 64px;">
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="h-2"></td>
                  </tr>
                  <tr>
                    <td colspan="3" class="text-left p-2">클리닝 및 교환된 필터의 품질은 해당 필터의 클리닝을 수행한 저감장치 제작사와 클리닝센터에서 보증하며, 3개월 이내에 필터로 인해 발생하는 장치 이상의 문제는 해당 저감장치 제작사에서 무상 A/S로 처리함을 확인합니다.</td>
                  </tr>
                  <tr>
                    <td colspan="3" class="h-2"></td>
                  </tr>
                  <tr>
                    <td class="text-center pl-32 pr-2 text-lg" colspan="2">클리닝센터(출장교환 작업자)</td>
                    <td style="position: relative;">
                      <span style="position: absolute; top: 4px; right: 110px;">(인)</span>
                      <img :src="audit.signatureEngineer" style="position: absolute; top: -16px; right: 90px; z-index: 0; width: 64px;">
                    </td>
                  </tr>
                  <tr>
                    <td colspan="3" class="h-2"></td>
                  </tr>
                  <tr>
                    <td class="text-right pr-2 text-lg">장치제작자</td>
                    <td class="text-left">HK-MNS</td>
                    <td class="text-left" style="position: relative"><img src="@/assets/images/hk-mns.png" class="img-hk-mns" style="position: absolute; top: -28px; z-index: 0; width: 90px;"></td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </vs-popup>
</template>

<script>
export default {
  data () {
    return {
      popupActive: false,
      audit: {}
    }
  },
  methods: {
    open (audit) {
      this.popupActive = true
      this.audit = audit
    },
    toggleRelation (value) {
      this.audit.relation = value
      this.audit = {
        ...this.audit
      }
    },
    checkAll () {
      if (!this.audit.checklist) {
        this.audit.checklist = {}
      }

      this.audit.checklist['compressure'] = 1
      this.audit.checklist['spray'] = 1
      this.audit.checklist['heat'] = 1
      this.audit.checklist['status'] = 1
      this.audit.checklist['backPressure'] = 1
      this.audit.checklist['pipe'] = 1
      this.audit.checklist['sensor'] = 1
      this.audit.checklist['error'] = 1
      this.audit.checklist['connector'] = 1
      this.audit.checklist['pressure'] = 1
      this.audit.checklist['manual'] = 1
      this.audit.checklist['self'] = 1
      this.audit = {
        ...this.audit
      }
    },
    toggleChecklist (type, value) {
      if (!this.audit.checklist) {
        this.audit.checklist = {}
      }
      
      if (this.audit.checklist[type] === value) {
        this.audit.checklist[type] = undefined
      } else {
        this.audit.checklist[type] = value
      }
      
      this.audit = {
        ...this.audit
      }
    },
    checkNormalCleaningNote (note) {
      if (this.audit.normalCleaningNote === note) {
        this.audit.normalCleaningNote = null
      } else {
        this.audit.normalCleaningNote = note
      }
      this.audit = {
        ...this.audit
      }
    },
    save () {
      this.$vs.loading()
      this.$db.collection('installations').doc(this.audit.id).update(this.audit).then(() => {
        this.$vs.loading.close()
        alert('저장되었습니다.')
      })
    },
    print () {
      const css = '@page { size: portrait; margin: 20px 40px; }'
      const head = document.head || document.getElementsByTagName('head')[0]
      const style = document.createElement('style')

      style.type = 'text/css'
      style.media = 'print'

      if (style.styleSheet) {
        style.styleSheet.cssText = css
      } else {
        style.appendChild(document.createTextNode(css))
      }

      head.appendChild(style)

      window.print()
    }
  }
}
</script>

<style lang="scss">

@media screen {
  .normal-cleaning-popup .vs-popup {
    width: 730px !important;
  }
  .img-seocheon {
    right: 98px;
  }
  .img-hk-mns {
    right: 80px;
  }
}

@media print {
  #app {
    display: none;
  }
  .normal-cleaning-page {
      width: 100%;
      background-color: white;
      position: absolute;
      top: 0;
      left: 0;
      margin: 0;
  }
  .img-seocheon {
    right: 88px;
  }
  .img-hk-mns {
    right: 70px;
  }
}

.normal-cleaning-popup table {
  // border: 1px solid #c8c8c8;
  border-collapse: collapse;
}

.normal-cleaning-popup table td, .normal-cleaning-popup table th {
  text-align: center;
  padding: 0 4px;
  border: 1px solid #000;
  height: 28px;
}

.normal-cleaning-popup table th {
  background-color: #efefef;
}

.normal-cleaning-popup table th.bg-white {
  border: none;
}

.detail-category-popup .vs-con-input-label {
  width: 100%;
}

.normal-cleaning-popup table .no-border td {
  border: none;
}

</style>
